// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__r5cMK","termAndConditionsTextWrapper":"styles_termAndConditionsTextWrapper__2wGED","termAndConditionsText":"styles_termAndConditionsText__9j6fB"};